import axios from "axios";
import { getCurrentLanguage } from "../components/Utils";

/*const baseURL = process.env.REACT_APP_BASE_URL; to run the application in local*/

const axiosInstance = axios.create({
  baseURL: window.location.origin,
});
const language = getCurrentLanguage();
/* interceptors */
axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.data?.Errors) {
      for (const error of err.response.data.Errors) {
        if (error?.message?.includes("InvalidAccessTokenException")) {
          window.alert(
            language === "hi_IN"
              ? "आपका सत्र समाप्त हो गया है। कृपया जारी रखने के लिए लॉगिन करें।"
              : "Your session has expired. Please log in to continue."
          );

          Object.keys(localStorage).forEach((key) => {
            if (key.startsWith("DfsWeb")) {
              localStorage.removeItem(key);
            }
          });
          sessionStorage.clear();
          window.location.href = `${window?.contextPath}/login`;
        }
      }
    }
    throw err;
  }
);

export default axiosInstance;
